import { graphql } from '@/generated/gql';

export const GET_RULE_VERSION_STATUSES = graphql(/* GraphQL */ `
  query GetRuleVersionStatuses($id: UUID!) {
    tesseract {
      rule(id: $id) {
        id
        status
        ruleVersion {
          id
          status
        }
      }
    }
  }
`);
